/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/BackToTop',[
    'jquery',
    'global/Logger'
], function ($, Logger) {
    'use strict';

    function init() {
        //$('body').prepend('<a href="#" class="backToTop"><abbr class="icon-arrow-bracket-up" title="Back to Top"></abbr></a>');
		$('<a href="#" class="backToTop"><abbr class="icon-arrow-bracket-up" title="Back to Top"></abbr></a>').insertBefore(".site-container");

        var amountScrolled = 300,
			topButton = $('a.backToTop');

        $(window).scroll(function () {
            if ($(window).scrollTop() > amountScrolled) {
                topButton.fadeIn('slow');
            } else {
                topButton.fadeOut('slow');
            }
        });

        topButton.on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0
            }, 'fast');
        });
    };

    var BackToTop = { init: init };

    Logger.debug('BackToTop.js Loaded:', BackToTop);

    return BackToTop;
});

